export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="font-heading text-xl font-bold text-background-50">布丁漫画</div>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              布丁漫画专注韩漫免费阅读，每日同步更新热门韩漫资源。
              精选韩漫推荐与排行，提供免费全集下拉式阅读体验，
              让韩漫爱好者畅享韩系画风与精彩剧情。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '推荐韩漫', href: '#cards' },
                { label: '韩漫排行', href: '#ranking' },
                { label: '热门话题', href: '#topics' },
                { label: '常见问答', href: '#faq' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">热门题材</h3>
            <ul className="space-y-2.5">
              {['校园恋爱', '奇幻冒险', '悬疑推理', '恶役千金', '都市职场'].map((t) => (
                <li key={t}>
                  <a
                    href="#topics"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              布丁漫画与多家韩漫内容平台及版权方保持合作，持续拓展优质韩漫正版资源。
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              {[
                '韩漫推荐', '韩漫排行', '免费韩漫',
                '下拉式阅读', '韩漫全集', '韩系漫画',
              ].map((kw) => (
                <span
                  key={kw}
                  className="px-2.5 py-1 text-xs rounded-full bg-background-800 text-background-400 whitespace-nowrap"
                >
                  {kw}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 布丁漫画 版权所有 | 韩漫免费全集下拉式阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}